export default "ui-tab{display:block}ui-tab:not([state]){visibility:hidden}\n";